/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.modals.confirmCustom.controllers', [])

.controller('ConfirmCustomModalController', ['$scope', '$uibModalInstance', '$sce', 'modalTitle', 'okText', 'cancelText', 'hideOkText', 'modalMessage', function($scope, $uibModalInstance, $sce, modalTitle, okText, cancelText, hideOkText, modalMessage) {

    $scope.confirmModal = {

      message: $sce.trustAsHtml(modalMessage || ''),
      title: modalTitle,
      saveText: okText,
      cancelText: cancelText,
      hideSaveText: hideOkText,

      init: function() {},

      close: function() {
        $uibModalInstance.dismiss('cancel');
      },

      done: function() {
        $uibModalInstance.close('success');
      }

    };

    $scope.confirmModal.init();

}]);